import { render, staticRenderFns } from "./company.vue?vue&type=template&id=ba571b2a&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=ba571b2a&prod&lang=scss&scoped=true"
import style1 from "./company.vue?vue&type=style&index=1&id=ba571b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba571b2a",
  null
  
)

export default component.exports